module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Gc-Ha-Ia.534e5dfa.png";